import DataWrapperChart from 'components/DataWrapperChart'
import React from 'react'
import styled from 'styled-components'

import cantons from '../../../data/cantons.json'

const Wrapper = styled.div`
  position: relative;
`

const CantonList = styled.div`
  background: #99999966;
  font-family: TamediaChart;
  display: flex;
  max-width: 626px;
  padding: 5px;
  flex-wrap: wrap;
  justify-content: center;
  margin: 15px auto 30px auto;
  @media (max-width: 600px) {
    margin: 15px auto 15px auto;
    position: sticky;
    top: 0;
  }
`

const CantonSelector = styled.div`
  padding: 0 6px;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  font-weight: ${props => props.selected ? 'bold' : 'heavy'};
  color: ${props => props.selected ? '#fff' : '#202346'};
  background-color: ${props => props.selected ? '#202346' : undefined};
`
const MapContainer = styled.div`
  display: grid;
  grid-gap: 20px;
  grid-template-columns: 1fr 1fr 1fr;
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`

const Header = styled.div`
  font-size: 24px;
  max-width: 626px;
  margin: auto;
  font-family: TamediaChart;
  font-weight: 600;
`

const SubHeader = styled.div`
  font-size: 16px;
  max-width: 626px;
  margin: 15px auto;
  font-family: TamediaChart;
  line-height: 1.4;
`

function MapSelector() {
  const [selected, setSelected] = React.useState('AG')

  const currentCanton = cantons.find(c => c.canton === selected)

  return (
    <Wrapper>
      <Header>Les trois vagues par canton</Header>
      <SubHeader>Sélectionnez un canton pour voir l’incidence des nouveaux cas confirmés par commune et pour chacune des trois vagues.</SubHeader>
      <CantonList>
        {cantons.map(c => (
          <CantonSelector selected={c.canton === selected} onClick={() => setSelected(c.canton)}>
            {c.canton}
          </CantonSelector>
        ))}
      </CantonList>
      {currentCanton && (
        <MapContainer>
          <DataWrapperChart key={currentCanton.kat_text_phase_1} chartId={currentCanton.kat_text_phase_1} height={400} />
          <DataWrapperChart key={currentCanton.kat_text_phase_2} chartId={currentCanton.kat_text_phase_2} height={400} />
          <DataWrapperChart key={currentCanton.kat_text_phase_3} chartId={currentCanton.kat_text_phase_3} height={400} />
        </MapContainer>
      )}
    </Wrapper>
  )
}

export default MapSelector
